export const projectLog = {
    projectLogList: {
        project: 'Project',
        action: 'Action',
        updatedBy: 'Updated By',
        updatedAt: 'Updated At',
        oldData: 'Old Data',
        newData: 'New Data',
    },
    breadcrumb: {
        projectLog: 'Project log',
        projectLogHistory: 'Project log',
        projectLogTransaction: 'Project log transaction',
        projectLogReport: 'Project log report',
        logServer: 'Log server',
    },
    action: {
        CREATE_PROJECT: 'Create a project',
        UPDATE_PROJECT: 'Update a project',
        DELETE_PROJECT: 'Delete a project',
        CREATE_PROJECT_GROUP: 'Create a project group',
        UPDATE_PROJECT_GROUP: 'Update a project group',
        DELETE_PROJECT_GROUP: 'Delete a project group',
        CREATE_PROJECT_PROFILE: 'Create a project profile',
        UPDATE_PROJECT_PROFILE: 'Update a project profile',
        DELETE_PROJECT_PROFILE: 'Delete a project profile',
        CREATE_USER: 'Create a user',
        UPDATE_USER: 'Update a user',
        DELETE_USER: 'Delete a user',
        ASSIGN_TO_PROJECT_USER: 'Assign a user to project',
        REMOVE_FROM_PROJECT_USER: 'Remove a user from project',
        ASSIGN_TO_PROJECT_GROUP: 'Assign a project group to project',
        REMOVE_FROM_PROJECT_GROUP: 'Remove a project group from project',
    },
    filterForm: {
        keyword: {
            label: 'Keyword',
            placeholder: 'Enter keyword',
        },
        project: {
            label: 'Project',
            placeholder: 'Select project',
        },
        company: {
            label: 'Company',
            placeholder: 'Select company',
        },
        dateRangeType: {
            label: 'View by',
            placeholder: 'Select view options',
        },
        dateRange: {
            label: 'Time',
            placeholder: 'Select time',
        },
        actions: {
            label: 'Action',
            placeholder: 'Select action',
        },
        updatedAtRange: {
            label: 'Updated At',
            to: 'To',
            startDate: 'Start Date',
            endDate: 'End Date',
        },
        module: {
            label: 'Access Module',
            placeholder: 'Select access module',
        },
        condition: {
            label: 'Condition',
            placeholder: 'Select condition',
            option: {
                and: 'And',
                or: 'Or',
            },
        },
    },
    chart: {
        userTime: 'User Time Chart',
        supportRequestCategory: 'Support Request Category Chart',
        userStatus: 'User Status Chart',
        projectCategory: 'Project Category Chart',
        usersInCompany: 'Users In Company Chart',
    },
    dateRangeType: {
        day: 'View by day',
        week: 'View by week',
        month: 'View by month',
        year: 'View by year',
    },
    logServer: {
        logServerType: {
            INSTANCE_LOG: 'Instance log',
            SERVER_LOG: 'Server log',
            LICENSE_LOG: 'License log',
        },
        kb: 'KB',
        header: {
            name: 'Name',
            modifiedDate: 'Modified date',
            size: 'Size',
            date: 'Date',
            type: 'Type',
        },
        placeholder: {
            date: 'Choose date',
            type: 'Choose type',
        },
    },
};
